import SessionEventProto from "../session-event-proto"

import {SESSION_PROJECT_DELETE, SESSION_PROJECTS_CHANGED} from "../../gd/bus/bus-event-type"
import {ProjectSystemType} from "../../model2/project/types"

// const debug = "EventProjectDelete"
const debug = false

export default class EventProjectDelete extends SessionEventProto {

    public header: {
        project     : any
        isBulkUpdate: boolean
    }

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.header     = {
            project     : sessionEvent.project,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    process() {
        const projectId = this.data.id
        let companyId = null

        // remove project from templates
        const sessionTemplate = gd.session.templatesList.get(projectId)
        if (sessionTemplate) {
            gd.session.templatesList.remove(sessionTemplate.id)
            companyId = sessionTemplate.companyId
        }

        // remove project from projects
        const sessionProject = gd.session.projects.get(projectId)
        if (sessionProject) {
            gd.session.projects.remove(sessionProject.id)
            // ToDo: update only projects that are affected by DELETE instead of reinit whole tree
            gd.session.projects.initTree()

            if (sessionProject.systemType === ProjectSystemType.DATABASE_INTERNAL) {
                gd.databases.deleteInternalDBByProjectId(sessionProject.id)
            }

            if (sessionProject.isWorkspace) {
                gd.spaces.workspaces.removeByProject(sessionProject)
            }

            gd.bus.triggerEvent(SESSION_PROJECTS_CHANGED)
            gd.bus.triggerEvent(SESSION_PROJECT_DELETE, sessionProject)
            companyId = sessionProject.companyId

            if (sessionProject.isTag) {
                gd.fields.resetTagsFields()
            }
        }

        // kill dashboard tiles
        let dashboardTilesToRemove = gd.session.dashboard.filter((dashboard: any)=>{
            return dashboard.tileType === gd.const.dashboard.type.PROJECT && dashboard.target === projectId
        })
        dashboardTilesToRemove.map((tile: any)=>{
            gd.session.dashboard.remove(tile)
        })

        // OLD NOT NEEDED ANYMORE remove all the notifications
        // if (gd.session.updates) gd.session.updates.deleteAllByProject(projectId);

        // don't get how companyId can be null but had error in Sentry like https://sentry.io/goodday/goodday-client-app/issues/667800218/?query=is:unresolved
        // this session event is sent to all users in company even if they didn't have this project
        /*if (!companyId) {
            gd.utils.captureErrorMessage('no project->company in delete project session event', {
                level: 'error', // one of 'info', 'warning', or 'error'
                extra: {
                    user: gd.session.me.id,
                    sessionTemplate: sessionTemplate,
                    sessionProject: sessionProject,
                    data: this.data,
                    dataJsonData: JSON.stringify(this.data)
                }
            });
        }*/

        gd.modelBus.newUpdate('project', this.method, this.header.project.id, this.data, this.header)

        debug && console.log(debug, 'process', companyId, this.data, this.header)

        // let's recreate the tree ?
        if (gd.tree && companyId) { // there is a chance when there is no tree when new user creates new company (!) so we skip it in here!
            gd.tree.resetCompanyProjects(companyId)
        }
    }
};

